import { render, staticRenderFns } from "./newThree.vue?vue&type=template&id=e627706c&scoped=true&"
import script from "./newThree.vue?vue&type=script&lang=js&"
export * from "./newThree.vue?vue&type=script&lang=js&"
import style0 from "./newThree.vue?vue&type=style&index=0&id=e627706c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e627706c",
  null
  
)

export default component.exports